import { JSXElementConstructor, ReactElement } from 'react';
import { FilterProps } from '../../model';

export type FilterElement<V = any> = ReactElement<
  FilterProps<V>,
  JSXElementConstructor<FilterProps<V>>
>;
